import {GeneralAction} from '../../../@types/actions';
import {GET_MONITOR_SETTINGS} from '../../../constants/MonitorConstants';

export const GetSettingsAction = (template: string): GeneralAction<string> => ({
    type: GET_MONITOR_SETTINGS,
    payload: template
});
